import { StringSerializer_getInstance11v9md0a7d9yk as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3qslfm3vqg6y3 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Message$Companion$$childSerializers$_anonymous__yfg1gj() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()));
}
function Message$Companion$$childSerializers$_anonymous__yfg1gj_0() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Message$Companion$$childSerializers$_anonymous__yfg1gj);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t6s_1 = [null, null, null, tmp_1, null, null, lazy(tmp_2, Message$Companion$$childSerializers$_anonymous__yfg1gj_0)];
      }
      x28() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.zegreatrob.coupling.logging.Message', this, 7);
        tmp0_serialDesc.s1y('level', false);
        tmp0_serialDesc.s1y('name', false);
        tmp0_serialDesc.s1y('message', false);
        tmp0_serialDesc.s1y('properties', false);
        tmp0_serialDesc.s1y('timestamp', false);
        tmp0_serialDesc.s1y('marker', true);
        tmp0_serialDesc.s1y('stackTrace', true);
        this.u6s_1 = tmp0_serialDesc;
      }
      v6s(encoder, value) {
        var tmp0_desc = this.u6s_1;
        var tmp1_output = encoder.y1q(tmp0_desc);
        var tmp2_cached = Companion_getInstance().t6s_1;
        tmp1_output.o1s(tmp0_desc, 0, value.w6s_1);
        tmp1_output.o1s(tmp0_desc, 1, value.x6s_1);
        tmp1_output.s1s(tmp0_desc, 2, StringSerializer_getInstance(), value.y6s_1);
        tmp1_output.s1s(tmp0_desc, 3, tmp2_cached[3].n3(), value.z6s_1);
        tmp1_output.o1s(tmp0_desc, 4, value.a6t_1);
        if (tmp1_output.w1s(tmp0_desc, 5) ? true : !(value.b6t_1 == null)) {
          tmp1_output.s1s(tmp0_desc, 5, StringSerializer_getInstance(), value.b6t_1);
        }
        if (tmp1_output.w1s(tmp0_desc, 6) ? true : !(value.c6t_1 == null)) {
          tmp1_output.s1s(tmp0_desc, 6, tmp2_cached[6].n3(), value.c6t_1);
        }
        tmp1_output.z1q(tmp0_desc);
      }
      i1m(encoder, value) {
        return this.v6s(encoder, value instanceof Message() ? value : THROW_CCE());
      }
      j1m(decoder) {
        var tmp0_desc = this.u6s_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.y1q(tmp0_desc);
        var tmp12_cached = Companion_getInstance().t6s_1;
        if (tmp11_input.o1r()) {
          tmp4_local0 = tmp11_input.i1r(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.i1r(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.m1r(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.m1r(tmp0_desc, 3, tmp12_cached[3].n3(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.i1r(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.m1r(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.m1r(tmp0_desc, 6, tmp12_cached[6].n3(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.p1r(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.i1r(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.i1r(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.m1r(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.m1r(tmp0_desc, 3, tmp12_cached[3].n3(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.i1r(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.m1r(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.m1r(tmp0_desc, 6, tmp12_cached[6].n3(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().d1o(tmp2_index);
            }
          }
        tmp11_input.z1q(tmp0_desc);
        return Message().d6t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      h1m() {
        return this.u6s_1;
      }
      i1z() {
        var tmp0_cached = Companion_getInstance().t6s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].n3()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[6].n3())];
      }
    }
    protoOf($).j1z = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var MessageClass;
function Message() {
  if (MessageClass === VOID) {
    class $ {
      constructor(level, name, message, properties, timestamp, marker, stackTrace) {
        Companion_getInstance();
        marker = marker === VOID ? null : marker;
        stackTrace = stackTrace === VOID ? null : stackTrace;
        this.w6s_1 = level;
        this.x6s_1 = name;
        this.y6s_1 = message;
        this.z6s_1 = properties;
        this.a6t_1 = timestamp;
        this.b6t_1 = marker;
        this.c6t_1 = stackTrace;
      }
      toString() {
        return 'Message(level=' + this.w6s_1 + ', name=' + this.x6s_1 + ', message=' + this.y6s_1 + ', properties=' + toString(this.z6s_1) + ', timestamp=' + this.a6t_1 + ', marker=' + this.b6t_1 + ', stackTrace=' + toString(this.c6t_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.w6s_1);
        result = imul(result, 31) + getStringHashCode(this.x6s_1) | 0;
        result = imul(result, 31) + (this.y6s_1 == null ? 0 : getStringHashCode(this.y6s_1)) | 0;
        result = imul(result, 31) + (this.z6s_1 == null ? 0 : hashCode(this.z6s_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6t_1) | 0;
        result = imul(result, 31) + (this.b6t_1 == null ? 0 : getStringHashCode(this.b6t_1)) | 0;
        result = imul(result, 31) + (this.c6t_1 == null ? 0 : hashCode(this.c6t_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Message()))
          return false;
        if (!(this.w6s_1 === other.w6s_1))
          return false;
        if (!(this.x6s_1 === other.x6s_1))
          return false;
        if (!(this.y6s_1 == other.y6s_1))
          return false;
        if (!equals(this.z6s_1, other.z6s_1))
          return false;
        if (!(this.a6t_1 === other.a6t_1))
          return false;
        if (!(this.b6t_1 == other.b6t_1))
          return false;
        if (!equals(this.c6t_1, other.c6t_1))
          return false;
        return true;
      }
      static d6t(seen0, level, name, message, properties, timestamp, marker, stackTrace, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance().u6s_1);
        }
        var $this = createThis(this);
        $this.w6s_1 = level;
        $this.x6s_1 = name;
        $this.y6s_1 = message;
        $this.z6s_1 = properties;
        $this.a6t_1 = timestamp;
        if (0 === (seen0 & 32))
          $this.b6t_1 = null;
        else
          $this.b6t_1 = marker;
        if (0 === (seen0 & 64))
          $this.c6t_1 = null;
        else
          $this.c6t_1 = stackTrace;
        return $this;
      }
    }
    initMetadataForClass($, 'Message', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    MessageClass = $;
  }
  return MessageClass;
}
//region block: exports
export {
  Message as Messageyu2c6n5qdmq,
  Companion_getInstance as Companion_getInstancevwry16b2g9ke,
};
//endregion

//# sourceMappingURL=Message.mjs.map
